import { LocalStorageKeys } from "@/shared/constants/local-storage-keys";

import { localStorageCheck } from "./local-storage-check";

export const deleteFromLocalStorage = (name: LocalStorageKeys) => {
	if (localStorageCheck()) {
		window.localStorage.removeItem(name);
	}
};
